
const Emitter = require('events');

const _ = require('lodash');

import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';

const Serializable = require('serializable');


function FormModelBase () {
	const self = Serializable({
		LastName: ko.observable(),
		FirstName: ko.observable().extend({
			required: true,
		}),
		MiddleName: ko.observable(),
		Email: ko.observable().extend({
			email: true,
		}),
		Phone: ko.observable(),
		CallTime: ko.observable(),
		Comment: ko.observable(),
	});

	_.extend(self, _.pick(_.bindAll(new Emitter), 'on', 'emit'));

	self.Working = ko.observable(false);
	self.IsProcessingPersonalData = ko.observable(false);

	self.ValidationGroup = kv.computedGroup(_.constant(self.serializable));

	return self;
}

module.exports = FormModelBase;

